module.exports = __webpack_public_path__ + "img/116.54447adc.jpg";